import React, { useEffect, useState, useRef, Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';
import { round } from 'mathjs';

import './scss/table.scss';
import Color from '@tool/color';
import { CloseIcon20 } from '@styled/icon';
import { newRate } from '@tool/index';

interface IProps {
  tableHead: any[],
  tableLeft: any[],
  tableRight: any[],
  type?: string,
}
interface IState {}

const IndicatorTable = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { tableHead, tableLeft, tableRight, type } = props;

  // 第二个参数 - 保留几位小数
  const clacRate = (value: any, digit: number = 1) => {
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(value)) return '-';
    if (value === null || value === '' || value === undefined) return '-';
    if (value === 0) return 0;
    return round(value * 100, digit);
  };

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section className="table-101010">
      <section className="left-10">
        <p className="title-00 line-00"><span>{type}</span></p>
        {tableLeft.map((text: any, index: number) => (
          <p key={index} className={['line-00'].join(' ')}>
            <span>{text}</span>
          </p>
        ))}
      </section>
      <section className="right-10">
        <section className="right-101 title-00">
          {tableHead.map((value: any, index: number) => (
            <span key={index} className="text-11">{value}</span>
          ))}
        </section>
        {tableRight.map((item: any, index: number) => (
          <section key={index}
            className={['right-101'].join(' ')}>
            {item?.map((value: any, idx: number) => (
              <span key={idx} className={[
                index === 0 ? 'text-00' : 'text-11',
                clacRate(value) > 0 ? 'up-00' : '',
                clacRate(value) < 0 ? 'down-00' : '',
                clacRate(value) === 0 ? 'equal-00' : '',
              ].join(' ')}>{newRate(value)}
              </span>
            ))}
          </section>
        ))}
      </section>
    </section>
  );
};

export default observer(IndicatorTable);
